function setPurchaseDataRows(data) {
  const purchaseData = data
  console.log(purchaseData)

  if (purchaseData === null || purchaseData === undefined) {
    console.log('ERROR')
    return
  }

  // remove current content
  $(".bank-purchases").empty()

  let totalAmount = 0

  // set data rows
  $.each(purchaseData, function (key, purchaseDetails) {
    const accountName = purchaseDetails.account_name
    const details = purchaseDetails.details
    const amount = purchaseDetails.amount
    const elementId = `${key}${purchaseDetails.account_id}`
    totalAmount += parseFloat(amount)

    $(".bank-purchases").append(
      `<tr data-key=${key} id='${elementId}'>
        <td class="bank-name" >${accountName}</td>
        <td class="bank-name" >${details}</td>
        <td class="amount text-right">${numberWithCommas(amount)}</td>
      </tr>`
    )
  })

  totalAmount = numberWithCommas(totalAmount)

  // set total row
  $(".bank-purchases").append(
    `<tr id='purchase-total'>
      <td><strong>TOTAL</strong></td>
      <td></td>
      <td class='total-sale text-right'>
        <strong>${totalAmount}</strong>
      </td>
    </tr>`)
}

function setBankDetails(view = 'edit', floatPurchaseIdAttr) {
  let floatPurchaseId = $('#add-float-purchase-form input[name="float_purchase[purchase_id]"').val()

  if (view === 'index') {
    floatPurchaseId = floatPurchaseIdAttr
  }
  const action = $('#add-float-purchase-form input[name="float_purchase[purchase_action]"').val()

  if (view === 'edit' && (action === 'create' || floatPurchaseId === null || floatPurchaseId === undefined)) {
    return
  }

  $.ajax({
    type: "post",
    url: `/float_purchase_details/${floatPurchaseId}`,
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    dataType: "json",
    success: function (data) {
      console.log(data)
      setPurchaseDataRows(data)
    },
    error: function (data) {
      console.log('An error occurred.');
      console.log(data);
    },
  });
}


function submitFloatPurchase() {
  $('#submit-ajax-form-btn').click(function () {
    disableSubmit()

    let errorString = [];

    const createdAt = $('#add-float-purchase-form input[name="float_purchase[created_at]"]').val()

    $('#add-float-purchase-form input[name="commit"]').prop("disabled", false)

    if (isEmpty(createdAt)) {
      errorString.push(' Purchase date cannot be blank');
    }

    if (errorString.length > 0) {
      toastNotification('error', errorString.join(','))
    } else {
      $('#spinner-modal').modal('show');

      const postUrl = $('#add-float-purchase-form').attr('action')
      const redirectUrl = '/float_purchases'
      const branchId = $('#add-float-purchase-form input[name="float_purchase[branch_id]"]').val()
      const cashSourceId = $(`select[name="float_purchase[cash_source_id]"] option:selected`).val()
      const purchaseAccountId = $('select[name="float_purchase[purchase_account_id]"] option:selected').val()
      const paymentOptions = getPaymentOptionsStorage()

      let action = "post"

      if ($('#add-float-purchase-form input[name="float_purchase[float_purchase_action]"').val() === 'update') {
        action = "patch"
      }

      $.ajax({
        type: action,
        url: postUrl,
        headers: {
          'X-CSRF-Token': csrfToken()
        },
        data: {
          payment_options: paymentOptions,
          float_purchase: {
            branch_id: branchId,
            created_at: createdAt,
            cash_source_id: cashSourceId,
            purchase_account_id: purchaseAccountId,
          }
        },
        dataType: "json",
        success: function (data) {
          removePaymentOptionData()
          window.location.replace(redirectUrl)
          console.log(data)
        },
        error: function (data) {
          disableSubmit()
          console.log('An error occurred.');
          console.log(data);
        },
      });
    }
  });
}

$(document).ready(function () {
  if ($('#add-float-purchase-form').length > 0) {
    submitFloatPurchase()
    clearFailedSubmit('#add-float-purchase-form')
  }

  $('.view-float-purchase-details').click(function () {
    const floatPurchaseId = $(this).data('float-purchase-id')
    setBankDetails('index', floatPurchaseId)
  })

});
